import { SolutionPageLayout } from '@/components/solutions/SolutionPageLayout';

const COVERAGE_CARDS = [
  {
    title: 'Submission intake',
    description:
      'Athena digitizes and ingests submissions, schedules, and loss runs — every risk arrives complete and structured, not as an inbox of PDFs.',
  },
  {
    title: 'Triage & assignment',
    description:
      'Submissions scored and routed by appetite, complexity, and priority — the right level of risk touch, automatically.',
  },
  {
    title: 'Risk assessment',
    description:
      'Atlas aggregates data across every submission and surfaces what matters, so underwriters make faster, better-supported decisions.',
  },
  {
    title: 'Quoting & issuance',
    description:
      'Personal lines and small commercial run straight through: complex risks are guided to a decision the underwriter owns.',
  },
  {
    title: 'Account servicing',
    description:
      'Establishing loss control service and processing mid-term policy changes handled by governed agents — with human approvals where rules require them.',
  },
  {
    title: 'Underwriting workbench',
    description:
      'One environment over your policy admin core — the queue, the file, the insights, and the digital workers, together.',
  },
];

export function UnderwritingPage() {
  return (
    <SolutionPageLayout
      title="Underwriting - CriticalBridge.AI"
      canonicalPath="/underwriting"
      crumbLabel="Underwriting"
      heroTitle="Underwrite more business. Touch less of it."
      heroSub="From submission to issue in one governed flow: complete, structured submissions on arrival, straight-through quoting where the risk allows it, and guided decisions on the risks that deserve an underwriter."
      coverage={{
        eyebrow: 'Coverage',
        title: 'The underwriting value chain, on one platform.',
        cards: COVERAGE_CARDS,
      }}
      governance={{
        eyebrow: 'Governance built in',
        title: 'Underwriting decisions you can defend.',
        body: 'Risk and pricing decisions carry full lineage; bias testing runs against your book on schedule; and unfair-discrimination guardrails are enforced in the flow, not audited after the fact. The same fabric answers the DOI and the EU AI Act.',
        linkTo: '/lighthouse',
        linkLabel: 'How governance works →',
      }}
    />
  );
}
